<template>
  <v-layout column wrap  style="overflow: hidden;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <v-btn icon @click="routeinfo()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <v-avatar size="40" style="background: #A80D00 !important;">
        <v-icon style="font-size: 24px; color: white !important;">far fa-list-alt</v-icon>
      </v-avatar>
      &nbsp;&nbsp;
      <v-toolbar-title style="text-align: left">ประวัติการใช้งาน <p style="font-size: 14px; margin-bottom: 0;">เครื่อง AED: {{data_aed.address_name}}</p> </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <div v-if="listHistory.length != 0" class="hidden-sm-and-down">
        <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ค้นหาจากชื่อผู้ป่วย หรือ ผู้ที่แจ้ง"
          class="textfieldSearch"
        ></v-text-field>
      </div> -->
    </v-toolbar>
    <!-- <div v-if="listHistory.length != 0" class="hidden-md-and-up">
      <v-text-field
        hide-details
        solo
        v-model="search"
        append-icon="search"
        label="ค้นหาจากชื่อผู้ป่วย หรือ ผู้ที่แจ้ง"
        class="textfieldSearch"
      ></v-text-field>
    </div> -->
    <v-layout class="pb-4" row wrap justify-center align-center style="margin-top: 20px;" v-if="listHistory.length != 0">
      <v-data-table
        :headers="headers"
        :items="listHistory"
        :items-per-page="limit"
        hide-default-footer
        fixed-header
        class="elevation-1 mx-4 data-table-container"
        style="width: 100%;"
        height="450px"
      >
        <template v-slot:item.address_name="{ item }">
          📍 {{item.address_name}}
        </template> 
        <template v-slot:item.company_name="{ item }">
          {{ (item.company_name) ? item.company_name : '-' }}
        </template> 
        <!-- <template v-slot:item.company_owner_name="{ item }">
          {{(item.company_owner_name)? item.company_owner_name:'-'}}
        </template> 
        <template v-slot:item.company_maintenance_name="{ item }">
          {{(item.company_maintenance_name)? item.company_maintenance_name:'-'}}
        </template>  -->
        <template v-slot:item.created_at="{ item }">
          <!-- {{ dateMoment(item.created_at)}} - {{ timeMoment(item.created_at)}}น. -->
          {{ dateMoment(item.created_at)}} เวลา {{ timeMoment(item.created_at)}}น.
        </template>
        <template v-slot:item.informer_phone="{ item }">
          {{ (item.informer_phone == '')? '-':item.informer_phone }}
        </template>
        <template v-slot:item.serial_number="{ item }">
          {{ (item.serial_number)? item.serial_number:'-' }}
        </template>
        <template v-slot:item.state="{ item }" >
          <div v-if="item.status == 'approve'">
            <span  style="color: #53CC82;"> ยืนยันแล้ว </span>&nbsp;&nbsp;&nbsp;
            <a @click="selectedDetailHistory(item)" style="color: black;float: right;">รายละเอียด <v-icon style="font-size: 12px;color: black;">fas fa-chevron-right</v-icon></a>
          </div>
          <div v-else-if="item.status == 'reject'">
            <span  style="color: #9A2414;"> ปฏิเสธแล้ว </span>&nbsp;&nbsp;&nbsp;
            <a @click="selectedDetailHistory(item)" style="color: black;float: right;">รายละเอียด <v-icon style="font-size: 12px;color: black;">fas fa-chevron-right</v-icon></a>
          </div>
          <div v-else>
            <v-row no-gutters>
              <v-col cols="8">
                <v-btn outlined small  color="#53CC82" @click="changestatushistory('approve',item.uid, 'ยืนยัน')">
                  ยืนยัน
                </v-btn>
                <v-btn outlined small  color="#9A2414" @click="changestatushistory('reject',item.uid, 'ปฏิเสธ')">
                  ปฏิเสธ
                </v-btn>
              </v-col>
              <v-col cols="4">
                <a @click="selectedDetailHistory(item)" style="color: black;float: right;">รายละเอียด <v-icon style="font-size: 12px;color: black;">fas fa-chevron-right</v-icon></a>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-data-table>
      <v-pagination color="#a81000" v-model="page_pagination" :total-visible="7" :length="total_page"></v-pagination>
    </v-layout>
    <v-layout row wrap justify-center align-center style="margin-top: 20px; height: 50vh;" v-else>
      <h2  style="margin-top: 50px;">ไม่พบข้อมูลประวัติการใช้งาน</h2>
    </v-layout>
    <ShowDetailHistory :dialogshow_historyDetail="dialogshow_historyDetail" :historyItem="historyItem" @closeshow_historyDetail="closeshow_historyDetail"></ShowDetailHistory>
  </v-layout>
</template>
<script>
  import ShowDetailHistory from '@/components/information_print/infor_history_modal'
import { Decode, Momenttime } from '@/services'
var _ = require('lodash')
var moment = require('moment')
export default {
  data () {
    return {
    BASE_URL: process.env.BASE_URL,
    items: [],
    selectKey: 'all',
    selectKeyStatus: 'all',
    itemsselectStatus:  [
      { text: 'ทั้งหมด', value: 'all' },
      { text: 'เปิดปัญหา', value: 'open' },
      { text: 'ยืนยันปัญหา', value: 'confirm' },
      { text: 'แก้ไขแล้ว', value: 'close' }
    ],
    search: '',
    headers: [
        { text: 'สถานที่', value: 'address_name' },
        { text: 'เจ้าของ', value: 'owner_name'},
        { text: 'หน่วยงานที่ดูแล', value: 'company_name' },
        { text: 'Serial Number', value: 'serial_number' },
        { text: 'ชื่อ-นามสกุลผู้ป่วย', value: 'full_name' },
        { text: 'เบอร์โทรคนแจ้ง', value: 'informer_phone' },
        { text: 'วันเวลาที่แจ้ง', value: 'created_at' },
        { text: 'จัดการ', value: 'state', width: '20%' }
      ],
    listHistory: [],
    aed_id: '',
    data_aed: {},
    dialogshow_historyDetail: false,
    historyItem: {},
    page_pagination: 1,
    limit: 10,
    total_page: 0
  }},
  created () {
    this.aed_id = this.$route.query.aed_id
    this.page_pagination = parseInt(this.$route.query.page)
    this.getlisthistoryAED()
    this.getDataAED()
    // if (this.$route.query.typeSearch == 'all' || this.$route.query.typeSearch == 'redcross' || this.$route.query.typeSearch == 'other') {
    //   this.selectKey = this.$route.query.typeSearch
    // }
  },
  components: {
    ShowDetailHistory
  },
  watch: {
    page_pagination () {
      window.history.replaceState(null, null, "?page=" + this.page_pagination + "&aed_id=" + this.aed_id)
      this.getlisthistoryAED()
    }
  },
  computed: {
    // listHistoryFile () {
    //   if (this.search !== '') {
    //     return this.listHistory.filter(post => {
    //       try{
    //         return post.patient_name.toLowerCase().includes(this.search.toLowerCase()) || post.patient_lastname.toLowerCase().includes(this.search.toLowerCase()) || post.name_create_by.toLowerCase().includes(this.search.toLowerCase())
    //       } catch(err) {
    //       }
    //     })
    //   } else {
    //     return this.listHistory
    //   }
    // }
  },
  methods: {
    closeshow_historyDetail (value) {
      this.historyItem = {}
      this.dialogshow_historyDetail = value
    },
    routeinfo () {
      this.$router.back()
    },
    getDataAED () {
      this.$api.getDataAED(this.aed_id).then((response) => {
        this.data_aed = response.data.data
      })
    },
    selectedDetailHistory (item) {
      // alert(item)
      this.historyItem = item
      this.dialogshow_historyDetail = true
      // this.$router.push('/information_issue?id='+item.issue_id)
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    changestatushistory (status, uid, text) {
      // console.log(index)
      var body = {
        "status": status,
        "uid": uid
      }


      this.$swal({
        text: 'คุณต้องการ' + text + 'การใช้งานนี้ใช่หรือไม่?',
        confirmButtonColor: text == 'ปฏิเสธ' ? '#a81000' : '#53CC82',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true,
        customClass: {
          popup: 'custom-swal-font'
        },
      }).then((result) => {
        if (result.value) {
          this.$api.changeStatusHistory(body).then((response) => {
            if (status == 'approve') {
              this.$swal( 'ยืนยันสำเร็จ', '', 'success' )
            } else {
              this.$swal( 'ปฏิเสธสำเร็จ', '', 'error' )
            }
            var index = _.findIndex(this.listHistory, function(o) { return o.uid == uid; })
            this.listHistory[index].status = status
            this.listHistory[index].approve_name = response.data.data.approve_name
            this.listHistory[index].approve_phone = response.data.data.approve_phone
          })
        }
      })
    },
    getlisthistoryAED () {
      // var body = {
      //   aed_id: this.aed_id
      // }
      var textparams = '?page='+this.page_pagination + '&limit='+this.limit+ '&aed_id='+this.aed_id
      this.$api.getlisthistoryAED(textparams).then((response) => {
        // console.log(response.data)
        this.listHistory = response.data.data.list_item
        this.total_page = response.data.data.total_page
        // this.listHistory = _.sortBy(this.listHistory, function(dateObj) {
        //   return new Date(dateObj.create_at)
        // }).reverse()
      })
    }
  }
}
</script>
<style media="screen" scoped>
/* >>>.v-textarea.v-text-field--full-width .v-text-field__slot .textarea {
  margin-top: 10px !important;
} */
>>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
}
>>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
}
>>>.theme--dark.v-icon {
    color: #a80e00 !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: #a80e00 !important;
}
>>>.v-select__selections {
  line-height: 26px !important;
}
>>>.v-select__selection--comma {
  color: #a80e00 !important;
}
>>>.v-input .v-label {
    height: 26px;
    line-height: 26px;
  }
>>>.v-list-item__title {
    line-height: 26px !important;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}

.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}

>>>.theme--light.v-data-table thead tr:last-child th {
    border-bottom: thin solid rgba(0,0,0,.12);
    background: #a80e00 !important;
    color: white !important;
}
>>>.v-data-table__wrapper {
    border-radius: 14px;
    overflow-x: auto;
}

>>>.data-table-container {
    width: 100%;
    max-width: 100%;
}

>>>.theme--light.v-data-table {
    border-radius: 14px !important;
    margin-bottom: 20px !important;
}
.textfieldSearch {
  width: 330px;display: -webkit-inline-box; margin-right: 20px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .textfieldSearch {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
}

>>>.primary {
    background-color: #a81000 !important;
    border-color: #a81000 !important;
}

>>>.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/listReport/Listhistory.vue